/**
 * Cervus Botica — fixed header reveal on scroll up (single controller)
 * Target: .header-wrapper (announcement bar + main nav)
 */
(function () {
  function initHeaderScroll() {
    const wrapper = document.querySelector('.header-wrapper');
    if (!wrapper || wrapper.dataset.headerScrollInit === 'true') return;

    wrapper.dataset.headerScrollInit = 'true';

    const anchor = document.querySelector('[data-header-anchor]');
    let lastScrollY = window.scrollY;
    let ticking = false;
    let scrollAccumulator = 0;

    const SCROLL_UP_THRESHOLD = -4;
    const SCROLL_DOWN_THRESHOLD = 10;
    const SCROLL_ACCUMULATOR_MAX = 28;

    function isLockedOpen() {
      return (
        document.body.classList.contains('search-open') ||
        document.body.classList.contains('menu-open') ||
        document.body.classList.contains('cart-open') ||
        document.body.classList.contains('account-open') ||
        document.querySelector('.section-editorial-nav.is-nav-dropdown-open') ||
        window.cervusCart?.isClosing?.() === true
      );
    }

    function shouldPauseHeaderScroll() {
      return window.cervusCart?.isClosing?.() === true;
    }

    function syncAnchor(active) {
      if (!anchor) return;

      if (active) {
        anchor.style.height = `${wrapper.offsetHeight}px`;
        anchor.hidden = false;
      } else {
        anchor.style.height = '0';
        anchor.hidden = true;
      }
    }

    function clearHideTransition() {
      wrapper.classList.remove('is-hiding');
    }

    function clearRevealTransition() {
      wrapper.classList.remove('is-revealing');
    }

    function showAtTop() {
      clearHideTransition();
      clearRevealTransition();
      wrapper.classList.remove('header-wrapper--active', 'is-visible');
      wrapper.style.transform = '';
      wrapper.style.opacity = '';
      wrapper.style.visibility = '';
      wrapper.style.pointerEvents = '';
      syncAnchor(false);
      scrollAccumulator = 0;
    }

    function showFloating() {
      if (isLockedOpen()) {
        clearHideTransition();
        clearRevealTransition();
        wrapper.classList.add('header-wrapper--active', 'is-visible');
        syncAnchor(true);
        scrollAccumulator = 0;
        return;
      }

      clearHideTransition();
      syncAnchor(true);
      wrapper.classList.add('header-wrapper--active');

      if (wrapper.classList.contains('is-visible')) {
        scrollAccumulator = 0;
        return;
      }

      clearRevealTransition();
      wrapper.classList.add('is-revealing');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          wrapper.classList.add('is-visible');
        });
      });

      scrollAccumulator = 0;
    }

    function hideFloating() {
      if (isLockedOpen()) {
        showFloating();
        return;
      }

      syncAnchor(true);
      wrapper.classList.add('header-wrapper--active');

      if (!wrapper.classList.contains('is-visible')) {
        clearHideTransition();
        wrapper.classList.remove('is-visible');
        return;
      }

      wrapper.classList.add('is-hiding');
      wrapper.classList.remove('is-visible');
      scrollAccumulator = 0;
    }

    function updateScrollAccumulator(delta) {
      if (delta === 0) return;

      if ((delta > 0 && scrollAccumulator < 0) || (delta < 0 && scrollAccumulator > 0)) {
        scrollAccumulator = delta;
        return;
      }

      scrollAccumulator += delta;
      scrollAccumulator = Math.max(-SCROLL_ACCUMULATOR_MAX, Math.min(SCROLL_ACCUMULATOR_MAX, scrollAccumulator));
    }

    function updateHeader() {
      if (shouldPauseHeaderScroll()) {
        ticking = false;
        return;
      }

      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY;

      if (window.Shopify && window.Shopify.designMode) {
        showAtTop();
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      if (currentScrollY <= 10) {
        showAtTop();
      } else {
        updateScrollAccumulator(delta);

        if (scrollAccumulator <= SCROLL_UP_THRESHOLD) {
          showFloating();
        } else if (scrollAccumulator >= SCROLL_DOWN_THRESHOLD && wrapper.classList.contains('is-visible')) {
          hideFloating();
        }
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    wrapper.addEventListener('transitionend', (event) => {
      if (event.target !== wrapper) return;
      if (event.propertyName !== 'transform' && event.propertyName !== 'opacity') return;

      if (wrapper.classList.contains('is-visible')) {
        clearRevealTransition();
        return;
      }

      clearHideTransition();
    });

    showAtTop();

    window.addEventListener(
      'scroll',
      () => {
        if (shouldPauseHeaderScroll()) return;

        if (!ticking) {
          window.requestAnimationFrame(updateHeader);
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      () => {
        if (wrapper.classList.contains('header-wrapper--active')) {
          syncAnchor(true);
        }
      },
      { passive: true }
    );

    document.addEventListener('shopify:section:select', showAtTop);
    document.addEventListener('shopify:section:deselect', showAtTop);

    window.cervusHeaderScroll = {
      show: () => {
        if (window.scrollY <= 10) showAtTop();
        else showFloating();
      },
      hide: hideFloating,
      syncScrollY: (scrollY) => {
        lastScrollY = scrollY;
        scrollAccumulator = 0;
      },
      element: wrapper,
    };

    window.cervusHeaderChrome = window.cervusHeaderScroll;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderScroll);
  } else {
    initHeaderScroll();
  }
})();
